<template>
    <div class="wrapper">
        <dash-header></dash-header>
        <sidebar></sidebar>
        <div class="content-wrapper">
            <!-- Content Header (Page header) -->
            <section class="content-header">
                <div class="container-fluid">
                    <div class="row mb-2">
                        <div class="col-sm-6">
                            <h1 class="m-0 title">Payment</h1>
                        </div><!-- /.col -->
                        <div class="col-sm-6">
                            <ol class="breadcrumb float-sm-right">
                                <li class="breadcrumb-item"><router-link to="/dash">Home</router-link></li>
                                <li class="breadcrumb-item active">Payment</li>
                            </ol>
                        </div><!-- /.col -->
                    </div><!-- /.row -->
                </div><!-- /.container-fluid -->
            </section>
            <!-- /.content-header -->

            <section class="content payment">
                <div class="container-fluid">
                    <div class="row">
                        <div class="col-lg-12">
                            <div class="card card_payment">
                                <div class="card-body">
                                    <h5 class="depo">Deposit Broker</h5>
                                    <h3 class="money">{{ transaction.deposit_amount | toCurrency }}</h3>
                                </div>
                            </div>

                            <div class="card card_item">
                                <div class="card-header">
                                    <h5 class="">Item</h5>
                                </div>
                                <div class="card-body">
                                    <div class="row">
                                        <div class="col-4">
                                            <figure class="item_image">
                                                <img :src="dataRobot.image" alt="">
                                            </figure>
                                        </div>
                                        <div class="col-8">
                                            <h5 class="item_name">{{ dataRobot.name ? dataRobot.name : '-' }}</h5>
                                            <!-- <h5 class="item_name">{{transaction.product_name ? transaction.product_name : '-'}}</h5> -->
                                            <p class="item_title">transaction Code :</p>
                                            <p class="item_value">
                                                {{ transaction.transaction_code }}
                                            </p>

                                            <div class="row">
                                                <div class="col-lg-4">
                                                    <p class="item_title">Product Type :</p>
                                                    <p class="item_value"
                                                        v-if="transaction.product_type == 'FUND_MANAGER'">
                                                        FUND MANAGER
                                                    </p>
                                                    <p class="item_value" v-else>
                                                        {{ transaction.product_type ? transaction.product_type : '-' }}
                                                    </p>
                                                </div>
                                                <div class="col-lg-4">
                                                    <p class="item_title">Risk Level :</p>
                                                    <p class="item_value">
                                                        <span class="badge badge-danger"
                                                            v-if="dataRobot.risk_level == 3">HIGH</span>
                                                        <span class="badge badge-warning"
                                                            v-else-if="dataRobot.risk_level == 2">MEDIUM</span>
                                                        <span class="badge badge-success" v-else>LOW</span>
                                                    </p>
                                                </div>
                                                <div class="col-lg-4">
                                                    <p class="item_title">Vendor :</p>
                                                    <p class="item_value">
                                                        {{ dataRobot.vendor.name }}
                                                    </p>
                                                </div>
                                            </div>
                                            <p class="item_title">Broker :</p>
                                            <p class="item_value">
                                                <img :src="brokerImage" width="60" alt="">
                                                {{ brokerName }}
                                            </p>
                                            <!-- <p class="item_title">Strategy :</p>
                                            <p class="item_value">
                                                Lorem ipsum dolor sit, amet consectetur adipisicing elit. Similique, earum.
                                            </p> -->
                                            <div class="item_title prices">

                                                <p class="text"
                                                    v-if="transaction.transaction_type == 'INITIAL_LICENSE'">Expert
                                                    Advisor</p>
                                                <p class="text"
                                                    v-if="transaction.transaction_type == 'SUBSCRIPTION_RENEWAL'">
                                                    Subscription Renewal</p>

                                                <p v-if="transaction.transaction_type == 'INITIAL_LICENSE'">: Rp {{ new
                                                    Intl.NumberFormat('id-ID').format(Number(parseInt(dataRobot.selling_price)).toFixed())
                                                    }}
                                                </p>
                                                <p v-if="transaction.transaction_type == 'SUBSCRIPTION_RENEWAL'">: Rp {{
                                                    new
                                                        Intl.NumberFormat('id-ID').format(Number(parseInt(transaction.payment_amount)).toFixed())
                                                    }}
                                                </p>
                                            </div>
                                            <div class="item_title prices">
                                                <p class="text">
                                                    Service fee
                                                </p>
                                                <p>: Rp {{ new
                                                    Intl.NumberFormat('id-ID').format(Number(parseInt(serviceFee)).toFixed())
                                                    }}
                                                </p>
                                            </div>
                                            <div class="item_title prices"
                                                v-if="transaction.transaction_type != 'SUBSCRIPTION_RENEWAL'">
                                                <p class="text">Ar<span class="text-danger">T</span>keys</p>
                                                <p v-if="artKey">: Rp {{ new
                                                    Intl.NumberFormat('id-ID').format(Number(parseInt(artKey)).toFixed())
                                                    }}
                                                </p>
                                                <p v-else-if="!artKey">: Rp 0</p>
                                            </div>
                                            <!-- <div class="item_title prices">
                                                <p class="text" >Service fee</p> <p >: Rp 4.500</p> </div> -->
                                            <div class="item_title prices">
                                                <p class="text">Total Payment Amount</p>
                                                <p v-if="transaction.transaction_type == 'INITIAL_LICENSE'">: Rp
                                                    {{
                                                        new Intl.NumberFormat('id-ID').format(Number(parseInt(
                                                            dataRobot.selling_price
                                                            + artKey
                                                            + serviceFee
                                                        )).toFixed())
                                                    }}
                                                </p>
                                                <p v-if="transaction.transaction_type == 'SUBSCRIPTION_RENEWAL'">: Rp
                                                    {{
                                                        new
                                                            Intl.NumberFormat('id-ID').format(Number(parseInt(transaction.payment_amount
                                                    + serviceFee)).toFixed())
                                                    }}
                                                </p>
                                            </div>
                                            <!-- <h5 class="item_price">
                                                $ {{transaction.payment_amount}}
                                            </h5> -->


                                            <div class="col-md-8 col-lg-5 bg-success p-2 px-4 rounded"
                                                v-if="transaction.status == 'SUCCESS'">
                                                <span class="text-bold">Payment Success</span>
                                            </div>
                                            <div class="col-md-8 col-lg-5 bg-secondary p-2 px-4 rounded"
                                                v-if="transaction.status == 'CANCELED'">
                                                <span class="text-bold">Transaction Canceled</span>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <!-- <div class="card card_history">
                                <div class="card-header">
                                    <h5>History</h5>
                                </div>
                                <div class="card-body">
                                    <div class="history_group">
                                        <div class="history_text">
                                            <h5 class="name">Bank BCA</h5>
                                            <p class="text">Lorem ipsum dolor sit amet consectetur, adipisicing elit.</p>

                                            <p class="time">
                                                <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 8.292 8.292">
                                                    <g id="time_icon" transform="translate(-292 -659)">
                                                        <path id="Path_250" data-name="Path 250" d="M4.146,0A4.146,4.146,0,1,1,0,4.146,4.146,4.146,0,0,1,4.146,0Z" transform="translate(292 659)" fill="#212121" opacity="0.5"/>
                                                        <path id="Path_250-2" data-name="Path 250" d="M1730.636,664.33H1728.5v-3.7h.592v3.106h1.544Z" transform="translate(-1432.65 -0.665)" fill="#212121"/>
                                                    </g>
                                                </svg>
                                                08/02/2022
                                            </p>
                                        </div>
                                        <div class="history_price">
                                            <svg xmlns="http://www.w3.org/2000/svg" width="24.622" height="24.508" viewBox="0 0 24.622 24.508">
                                                <g id="money_out_icon" transform="translate(0 7.284)">
                                                    <path id="Subtraction_8" data-name="Subtraction 8" d="M3.93,14.182h0c-.392,0-.723-.017-1.043-.033-.271-.014-.526-.026-.783-.026A4.383,4.383,0,0,0,0,12.1V10.889c0-.061,0-6.172.012-6.769a4.678,4.678,0,0,0,1.843-1.7c.1.007.156.011.2.015.151.013.151.013,1.594.04l.737.013a28.781,28.781,0,0,0,6.442-1.156c1.281-.323,2.606-.657,3.912-.908.7-.136,1.341-.235,1.944-.3A16.421,16.421,0,0,1,18.575,0a11.848,11.848,0,0,1,1.265.065c.01.02.117.212.292.469a5.656,5.656,0,0,0,.682.833,4.4,4.4,0,0,0,.8.607,3.985,3.985,0,0,0,.394.21c0,.007,0,.076,0,.2.011,2.728.031,7.363.031,7.754a4.234,4.234,0,0,0-1.885,1.632l-.079-.006c-.5-.04-.887-.072-1.292-.072-.1,0-.191,0-.286.006h-.219a25.241,25.241,0,0,0-6.74,1.091h0l-1.036.258c-.826.23-1.6.427-2.31.585-.642.144-1.247.26-1.8.347A15.643,15.643,0,0,1,3.93,14.182Zm7.084-11c-1.779,0-3.227,1.752-3.227,3.906S9.234,11,11.014,11s3.227-1.752,3.227-3.906S12.793,3.185,11.014,3.185Z" transform="translate(1.308 1.483)" fill="#212121" opacity="0.5"/>
                                                    <path id="Subtraction_7" data-name="Subtraction 7" d="M5.43,17.224c-.093,0-.184,0-.27-.005a12.715,12.715,0,0,1-1.433-.109c-.425-.056-.854-.134-1.272-.23A10.015,10.015,0,0,1,.7,16.326,1.153,1.153,0,0,1,.3,16.02a1.212,1.212,0,0,1-.208-.36A1.315,1.315,0,0,1,0,15.236C0,15.123,0,3.91,0,3.057a1.392,1.392,0,0,1,.114-.55,1.273,1.273,0,0,1,.676-.664,1.129,1.129,0,0,1,.427-.088c.027,0,.054,0,.08,0a1.84,1.84,0,0,1,.489.131A9.518,9.518,0,0,0,5.2,2.384a29.938,29.938,0,0,0,7.148-1.2C13.5.895,14.692.594,15.864.373,16.5.253,17.07.166,17.623.1a16.031,16.031,0,0,1,1.76-.1l.2,0a12.391,12.391,0,0,1,1.367.076,12.026,12.026,0,0,1,1.2.2,8.416,8.416,0,0,1,1.731.552,1.32,1.32,0,0,1,.463.351,1.209,1.209,0,0,1,.216.4,1.244,1.244,0,0,1,.062.457V14.151a1.153,1.153,0,0,1-.107.479,1.41,1.41,0,0,1-.28.4,1.386,1.386,0,0,1-.39.278,1.025,1.025,0,0,1-.436.1.832.832,0,0,1-.108-.007,3.791,3.791,0,0,1-.534-.126,12.7,12.7,0,0,0-3.371-.47h-.16a34.575,34.575,0,0,0-7.047,1.207l-.153.037-.048.011c-1.257.3-2.444.583-3.562.8-.6.116-1.124.2-1.6.261a11.277,11.277,0,0,1-1.395.1h0ZM3.649,4.137a4.189,4.189,0,0,1-.771.936,4.848,4.848,0,0,1-.974.68c-.007.562-.011,6.187-.011,6.426h0v1.154a4.152,4.152,0,0,1,1.15.78,4.111,4.111,0,0,1,.843,1.137c.243,0,.485.012.741.025.3.015.616.031.987.031h0a22.506,22.506,0,0,0,6.224-1.082l.978-.244h0c1.3-.326,2.327-.584,3.318-.761a16.69,16.69,0,0,1,3.065-.275h.207c.09,0,.178-.005.271-.005.384,0,.755.03,1.224.069l.075.006a3.985,3.985,0,0,1,1.785-1.55c0-.473-.029-7.477-.03-7.547h0a3.854,3.854,0,0,1-.373-.2,4.164,4.164,0,0,1-.758-.576,5.366,5.366,0,0,1-.646-.791c-.165-.244-.267-.426-.276-.445a11.194,11.194,0,0,0-1.2-.062A31.286,31.286,0,0,0,12.146,3.1a27.194,27.194,0,0,1-6.1,1.1l-.7-.013c-1.367-.025-1.367-.025-1.51-.038C3.8,4.148,3.746,4.143,3.649,4.137Z" transform="translate(0)" fill="#212121"/>
                                                    <path id="Path_249" data-name="Path 249" d="M1.714-.66V-5.727h.325V-.66Zm1.016-3.5a.581.581,0,0,0-.261-.436,1.009,1.009,0,0,0-.578-.155,1.089,1.089,0,0,0-.432.078.668.668,0,0,0-.282.214.506.506,0,0,0-.1.308.447.447,0,0,0,.068.249.579.579,0,0,0,.18.175,1.248,1.248,0,0,0,.241.117,2.545,2.545,0,0,0,.247.076l.4.1a3.02,3.02,0,0,1,.4.129,1.6,1.6,0,0,1,.378.214,1.035,1.035,0,0,1,.282.329.959.959,0,0,1,.108.469,1.082,1.082,0,0,1-.177.612,1.2,1.2,0,0,1-.513.422,1.929,1.929,0,0,1-.811.154,1.967,1.967,0,0,1-.788-.145,1.21,1.21,0,0,1-.521-.411,1.183,1.183,0,0,1-.208-.632H.972a.619.619,0,0,0,.144.365.75.75,0,0,0,.323.216,1.279,1.279,0,0,0,.433.07,1.223,1.223,0,0,0,.462-.082.762.762,0,0,0,.32-.23.54.54,0,0,0,.117-.345.428.428,0,0,0-.1-.295.772.772,0,0,0-.275-.19A2.732,2.732,0,0,0,2-2.91l-.479-.131a1.856,1.856,0,0,1-.771-.39.875.875,0,0,1-.284-.681,1.012,1.012,0,0,1,.19-.612,1.255,1.255,0,0,1,.515-.407A1.772,1.772,0,0,1,1.9-5.276a1.731,1.731,0,0,1,.727.145,1.229,1.229,0,0,1,.5.4,1.008,1.008,0,0,1,.19.579Z" transform="translate(10.451 11.769)" fill="#212121"/>
                                                    <path id="Icon_awesome-arrow-up" data-name="Icon awesome-arrow-up" d="M.816,5.937.5,5.619a.343.343,0,0,1,0-.486L3.283,2.348a.343.343,0,0,1,.486,0L6.553,5.132a.343.343,0,0,1,0,.486l-.318.318a.344.344,0,0,1-.492-.006L4.1,4.2V8.323a.343.343,0,0,1-.344.344H3.3a.343.343,0,0,1-.344-.344V4.2L1.308,5.932A.342.342,0,0,1,.816,5.937Z" transform="translate(8.785 -9.53)" fill="#212121" opacity="0.5"/>
                                                </g>
                                            </svg>
                                            <span class="money">- Rp. 99.000</span>
                                        </div>
                                    </div>
                                </div>
                            </div> -->
                        </div>

                        <div class="col-lg-4">
                            <div class="button" v-if="subscription.installation_status == 'EXPIRED' && transaction.status != 'PENDING' ">
                                <button type="submit" class="btn btn_red" data-toggle="modal" data-target="#renew">
                                    <svg xmlns="http://www.w3.org/2000/svg" width="24.622" height="17.224"
                                        viewBox="0 0 24.622 17.224">
                                        <g id="money_icon" transform="translate(0)">
                                            <path id="Subtraction_8" data-name="Subtraction 8"
                                                d="M3.93,14.182h0c-.392,0-.723-.017-1.043-.033-.271-.014-.526-.026-.783-.026A4.383,4.383,0,0,0,0,12.1V10.889c0-.061,0-6.172.012-6.769a4.678,4.678,0,0,0,1.843-1.7c.1.007.156.011.2.015.151.013.151.013,1.594.04l.737.013a28.781,28.781,0,0,0,6.442-1.156c1.281-.323,2.606-.657,3.912-.908.7-.136,1.341-.235,1.944-.3A16.421,16.421,0,0,1,18.575,0a11.848,11.848,0,0,1,1.265.065c.01.02.117.212.292.469a5.656,5.656,0,0,0,.682.833,4.4,4.4,0,0,0,.8.607,3.985,3.985,0,0,0,.394.21c0,.007,0,.076,0,.2.011,2.728.031,7.363.031,7.754a4.234,4.234,0,0,0-1.885,1.632l-.079-.006c-.5-.04-.887-.072-1.292-.072-.1,0-.191,0-.286.006h-.219a25.241,25.241,0,0,0-6.74,1.091h0l-1.036.258c-.826.23-1.6.427-2.31.585-.642.144-1.247.26-1.8.347A15.643,15.643,0,0,1,3.93,14.182Zm7.084-11c-1.779,0-3.227,1.752-3.227,3.906S9.234,11,11.014,11s3.227-1.752,3.227-3.906S12.793,3.185,11.014,3.185Z"
                                                transform="translate(1.308 1.483)" fill="#fff" opacity="0.5" />
                                            <path id="Subtraction_7" data-name="Subtraction 7"
                                                d="M5.43,17.224c-.093,0-.184,0-.27-.005a12.715,12.715,0,0,1-1.433-.109c-.425-.056-.854-.134-1.272-.23A10.015,10.015,0,0,1,.7,16.326,1.153,1.153,0,0,1,.3,16.02a1.212,1.212,0,0,1-.208-.36A1.315,1.315,0,0,1,0,15.236C0,15.123,0,3.91,0,3.057a1.392,1.392,0,0,1,.114-.55,1.273,1.273,0,0,1,.676-.664,1.129,1.129,0,0,1,.427-.088c.027,0,.054,0,.08,0a1.84,1.84,0,0,1,.489.131A9.518,9.518,0,0,0,5.2,2.384a29.938,29.938,0,0,0,7.148-1.2C13.5.895,14.692.594,15.864.373,16.5.253,17.07.166,17.623.1a16.031,16.031,0,0,1,1.76-.1l.2,0a12.391,12.391,0,0,1,1.367.076,12.026,12.026,0,0,1,1.2.2,8.416,8.416,0,0,1,1.731.552,1.32,1.32,0,0,1,.463.351,1.209,1.209,0,0,1,.216.4,1.244,1.244,0,0,1,.062.457V14.151a1.153,1.153,0,0,1-.107.479,1.41,1.41,0,0,1-.28.4,1.386,1.386,0,0,1-.39.278,1.025,1.025,0,0,1-.436.1.832.832,0,0,1-.108-.007,3.791,3.791,0,0,1-.534-.126,12.7,12.7,0,0,0-3.371-.47h-.16a34.575,34.575,0,0,0-7.047,1.207l-.153.037-.048.011c-1.257.3-2.444.583-3.562.8-.6.116-1.124.2-1.6.261a11.277,11.277,0,0,1-1.395.1h0ZM3.649,4.137a4.189,4.189,0,0,1-.771.936,4.848,4.848,0,0,1-.974.68c-.007.562-.011,6.187-.011,6.426h0v1.154a4.152,4.152,0,0,1,1.15.78,4.111,4.111,0,0,1,.843,1.137c.243,0,.485.012.741.025.3.015.616.031.987.031h0a22.506,22.506,0,0,0,6.224-1.082l.978-.244h0c1.3-.326,2.327-.584,3.318-.761a16.69,16.69,0,0,1,3.065-.275h.207c.09,0,.178-.005.271-.005.384,0,.755.03,1.224.069l.075.006a3.985,3.985,0,0,1,1.785-1.55c0-.473-.029-7.477-.03-7.547h0a3.854,3.854,0,0,1-.373-.2,4.164,4.164,0,0,1-.758-.576,5.366,5.366,0,0,1-.646-.791c-.165-.244-.267-.426-.276-.445a11.194,11.194,0,0,0-1.2-.062A31.286,31.286,0,0,0,12.146,3.1a27.194,27.194,0,0,1-6.1,1.1l-.7-.013c-1.367-.025-1.367-.025-1.51-.038C3.8,4.148,3.746,4.143,3.649,4.137Z"
                                                transform="translate(0)" fill="#fff" />
                                            <path id="Path_249" data-name="Path 249"
                                                d="M1.714-.66V-5.727h.325V-.66Zm1.016-3.5a.581.581,0,0,0-.261-.436,1.009,1.009,0,0,0-.578-.155,1.089,1.089,0,0,0-.432.078.668.668,0,0,0-.282.214.506.506,0,0,0-.1.308.447.447,0,0,0,.068.249.579.579,0,0,0,.18.175,1.248,1.248,0,0,0,.241.117,2.545,2.545,0,0,0,.247.076l.4.1a3.02,3.02,0,0,1,.4.129,1.6,1.6,0,0,1,.378.214,1.035,1.035,0,0,1,.282.329.959.959,0,0,1,.108.469,1.082,1.082,0,0,1-.177.612,1.2,1.2,0,0,1-.513.422,1.929,1.929,0,0,1-.811.154,1.967,1.967,0,0,1-.788-.145,1.21,1.21,0,0,1-.521-.411,1.183,1.183,0,0,1-.208-.632H.972a.619.619,0,0,0,.144.365.75.75,0,0,0,.323.216,1.279,1.279,0,0,0,.433.07,1.223,1.223,0,0,0,.462-.082.762.762,0,0,0,.32-.23.54.54,0,0,0,.117-.345.428.428,0,0,0-.1-.295.772.772,0,0,0-.275-.19A2.732,2.732,0,0,0,2-2.91l-.479-.131a1.856,1.856,0,0,1-.771-.39.875.875,0,0,1-.284-.681,1.012,1.012,0,0,1,.19-.612,1.255,1.255,0,0,1,.515-.407A1.772,1.772,0,0,1,1.9-5.276a1.731,1.731,0,0,1,.727.145,1.229,1.229,0,0,1,.5.4,1.008,1.008,0,0,1,.19.579Z"
                                                transform="translate(10.451 11.769)" fill="#fff" />
                                        </g>
                                    </svg>
                                    Renew Payment Link
                                </button>
                            </div>
                            <div class="button" v-if="transaction.status == 'PENDING'">
                                <button type="submit" class="btn btn_red" data-toggle="modal" data-target="#payment">
                                    <svg xmlns="http://www.w3.org/2000/svg" width="24.622" height="17.224"
                                        viewBox="0 0 24.622 17.224">
                                        <g id="money_icon" transform="translate(0)">
                                            <path id="Subtraction_8" data-name="Subtraction 8"
                                                d="M3.93,14.182h0c-.392,0-.723-.017-1.043-.033-.271-.014-.526-.026-.783-.026A4.383,4.383,0,0,0,0,12.1V10.889c0-.061,0-6.172.012-6.769a4.678,4.678,0,0,0,1.843-1.7c.1.007.156.011.2.015.151.013.151.013,1.594.04l.737.013a28.781,28.781,0,0,0,6.442-1.156c1.281-.323,2.606-.657,3.912-.908.7-.136,1.341-.235,1.944-.3A16.421,16.421,0,0,1,18.575,0a11.848,11.848,0,0,1,1.265.065c.01.02.117.212.292.469a5.656,5.656,0,0,0,.682.833,4.4,4.4,0,0,0,.8.607,3.985,3.985,0,0,0,.394.21c0,.007,0,.076,0,.2.011,2.728.031,7.363.031,7.754a4.234,4.234,0,0,0-1.885,1.632l-.079-.006c-.5-.04-.887-.072-1.292-.072-.1,0-.191,0-.286.006h-.219a25.241,25.241,0,0,0-6.74,1.091h0l-1.036.258c-.826.23-1.6.427-2.31.585-.642.144-1.247.26-1.8.347A15.643,15.643,0,0,1,3.93,14.182Zm7.084-11c-1.779,0-3.227,1.752-3.227,3.906S9.234,11,11.014,11s3.227-1.752,3.227-3.906S12.793,3.185,11.014,3.185Z"
                                                transform="translate(1.308 1.483)" fill="#fff" opacity="0.5" />
                                            <path id="Subtraction_7" data-name="Subtraction 7"
                                                d="M5.43,17.224c-.093,0-.184,0-.27-.005a12.715,12.715,0,0,1-1.433-.109c-.425-.056-.854-.134-1.272-.23A10.015,10.015,0,0,1,.7,16.326,1.153,1.153,0,0,1,.3,16.02a1.212,1.212,0,0,1-.208-.36A1.315,1.315,0,0,1,0,15.236C0,15.123,0,3.91,0,3.057a1.392,1.392,0,0,1,.114-.55,1.273,1.273,0,0,1,.676-.664,1.129,1.129,0,0,1,.427-.088c.027,0,.054,0,.08,0a1.84,1.84,0,0,1,.489.131A9.518,9.518,0,0,0,5.2,2.384a29.938,29.938,0,0,0,7.148-1.2C13.5.895,14.692.594,15.864.373,16.5.253,17.07.166,17.623.1a16.031,16.031,0,0,1,1.76-.1l.2,0a12.391,12.391,0,0,1,1.367.076,12.026,12.026,0,0,1,1.2.2,8.416,8.416,0,0,1,1.731.552,1.32,1.32,0,0,1,.463.351,1.209,1.209,0,0,1,.216.4,1.244,1.244,0,0,1,.062.457V14.151a1.153,1.153,0,0,1-.107.479,1.41,1.41,0,0,1-.28.4,1.386,1.386,0,0,1-.39.278,1.025,1.025,0,0,1-.436.1.832.832,0,0,1-.108-.007,3.791,3.791,0,0,1-.534-.126,12.7,12.7,0,0,0-3.371-.47h-.16a34.575,34.575,0,0,0-7.047,1.207l-.153.037-.048.011c-1.257.3-2.444.583-3.562.8-.6.116-1.124.2-1.6.261a11.277,11.277,0,0,1-1.395.1h0ZM3.649,4.137a4.189,4.189,0,0,1-.771.936,4.848,4.848,0,0,1-.974.68c-.007.562-.011,6.187-.011,6.426h0v1.154a4.152,4.152,0,0,1,1.15.78,4.111,4.111,0,0,1,.843,1.137c.243,0,.485.012.741.025.3.015.616.031.987.031h0a22.506,22.506,0,0,0,6.224-1.082l.978-.244h0c1.3-.326,2.327-.584,3.318-.761a16.69,16.69,0,0,1,3.065-.275h.207c.09,0,.178-.005.271-.005.384,0,.755.03,1.224.069l.075.006a3.985,3.985,0,0,1,1.785-1.55c0-.473-.029-7.477-.03-7.547h0a3.854,3.854,0,0,1-.373-.2,4.164,4.164,0,0,1-.758-.576,5.366,5.366,0,0,1-.646-.791c-.165-.244-.267-.426-.276-.445a11.194,11.194,0,0,0-1.2-.062A31.286,31.286,0,0,0,12.146,3.1a27.194,27.194,0,0,1-6.1,1.1l-.7-.013c-1.367-.025-1.367-.025-1.51-.038C3.8,4.148,3.746,4.143,3.649,4.137Z"
                                                transform="translate(0)" fill="#fff" />
                                            <path id="Path_249" data-name="Path 249"
                                                d="M1.714-.66V-5.727h.325V-.66Zm1.016-3.5a.581.581,0,0,0-.261-.436,1.009,1.009,0,0,0-.578-.155,1.089,1.089,0,0,0-.432.078.668.668,0,0,0-.282.214.506.506,0,0,0-.1.308.447.447,0,0,0,.068.249.579.579,0,0,0,.18.175,1.248,1.248,0,0,0,.241.117,2.545,2.545,0,0,0,.247.076l.4.1a3.02,3.02,0,0,1,.4.129,1.6,1.6,0,0,1,.378.214,1.035,1.035,0,0,1,.282.329.959.959,0,0,1,.108.469,1.082,1.082,0,0,1-.177.612,1.2,1.2,0,0,1-.513.422,1.929,1.929,0,0,1-.811.154,1.967,1.967,0,0,1-.788-.145,1.21,1.21,0,0,1-.521-.411,1.183,1.183,0,0,1-.208-.632H.972a.619.619,0,0,0,.144.365.75.75,0,0,0,.323.216,1.279,1.279,0,0,0,.433.07,1.223,1.223,0,0,0,.462-.082.762.762,0,0,0,.32-.23.54.54,0,0,0,.117-.345.428.428,0,0,0-.1-.295.772.772,0,0,0-.275-.19A2.732,2.732,0,0,0,2-2.91l-.479-.131a1.856,1.856,0,0,1-.771-.39.875.875,0,0,1-.284-.681,1.012,1.012,0,0,1,.19-.612,1.255,1.255,0,0,1,.515-.407A1.772,1.772,0,0,1,1.9-5.276a1.731,1.731,0,0,1,.727.145,1.229,1.229,0,0,1,.5.4,1.008,1.008,0,0,1,.19.579Z"
                                                transform="translate(10.451 11.769)" fill="#fff" />
                                        </g>
                                    </svg>
                                    Pay Now
                                </button>
                            </div>
                        </div>

                        <!-- <div class="col-lg-4">
                            <h5 class="payment_title">Payment with</h5>
                            <div class="payment_card_container">
                                <swiper ref="mySwiper" :options="swiperOptions">
                                    <swiper-slide>
                                        <div class="card_group">
                                            <input type="radio" class="radio" name="cards" id="cards">
                                            <label for="cards" class="card bank_card">
                                                <div class="card-header">
                                                    <h3 class="card-title">Dela Prayoga</h3>
                                                    <div class="card-tools">
                                                        <span class="mr-2 fw-bold">BCA</span>
                                                    </div>
                                                </div>
                                                <div class="card-body">
                                                    <div class="chip">
                                                        <svg xmlns="http://www.w3.org/2000/svg" width="40" height="30" viewBox="0 0 40 30">
                                                            <path id="chip_icon" d="M37,30H25.213v-6.41A5.688,5.688,0,0,0,27.247,22.2a6.883,6.883,0,0,0,.75-.942V21.3H40V27A3,3,0,0,1,37,30ZM24.214,30H15.787V23.229l0-.4-.391-.087a4.423,4.423,0,0,1-1.968-1.283c-1.3-1.391-1.989-3.584-1.989-6.342a9.509,9.509,0,0,1,2-6.446,4.774,4.774,0,0,1,1.976-1.376l.373-.1V0h8.427V7.195l.371.1a4.779,4.779,0,0,1,1.978,1.377,9.509,9.509,0,0,1,2,6.446c0,2.758-.688,4.951-1.989,6.342A4.421,4.421,0,0,1,24.6,22.741l-.393.088,0,.4V30Zm-9.427,0H3a3,3,0,0,1-3-3V21.3H12v-.049a6.816,6.816,0,0,0,.75.942,5.693,5.693,0,0,0,2.034,1.392V30ZM40,20.3H28.534a12.008,12.008,0,0,0,1.026-5.189,12.732,12.732,0,0,0-.841-4.811H40v10Zm-28.534,0H0v-10H11.282a12.712,12.712,0,0,0-.842,4.811A12.012,12.012,0,0,0,11.465,20.3ZM40,9.306H28.235a7.37,7.37,0,0,0-.98-1.36,6.045,6.045,0,0,0-2.041-1.482V0H37a3,3,0,0,1,3,3v6.3Zm-28.236,0H0V3A3,3,0,0,1,3,0H14.787V6.463a6.036,6.036,0,0,0-2.041,1.482A7.33,7.33,0,0,0,11.765,9.3Z" transform="translate(0 0)" fill="#fff"/>
                                                        </svg>
                                                    </div>
                                                    <p class="acc_number m-0">No.Rek</p>
                                                    <h5 class="number fw-bold">0014 2154 3355 1803</h5>

                                                    <div class="branch_name fw-bold">
                                                        <p>KCP Ubud</p>
                                                        <svg xmlns="http://www.w3.org/2000/svg" width="43" height="28.289" viewBox="0 0 43 28.289">
                                                            <g id="mastercard_icon" transform="translate(-551 -339.628)">
                                                                <circle id="Ellipse_1" data-name="Ellipse 1" cx="14.145" cy="14.145" r="14.145" transform="translate(551 339.628)" fill="#fff" opacity="0.52"/>
                                                                <circle id="Ellipse_2" data-name="Ellipse 2" cx="14.145" cy="14.145" r="14.145" transform="translate(565.71 339.628)" fill="#fff"/>
                                                            </g>
                                                        </svg>
                                                    </div>
                                                </div>
                                            </label>
                                        </div>
                                    </swiper-slide>
                                    <swiper-slide>
                                        <div class="card_group">
                                            <input type="radio" class="radio" name="cards" id="cards2">
                                            <label for="cards2" class="card bank_card">
                                                <div class="card-header">
                                                    <h3 class="card-title">Dela Prayoga</h3>
                                                    <div class="card-tools">
                                                        <span class="mr-2 fw-bold">BCA</span>
                                                    </div>
                                                </div>
                                                <div class="card-body">
                                                    <div class="chip">
                                                        <svg xmlns="http://www.w3.org/2000/svg" width="40" height="30" viewBox="0 0 40 30">
                                                            <path id="chip_icon" d="M37,30H25.213v-6.41A5.688,5.688,0,0,0,27.247,22.2a6.883,6.883,0,0,0,.75-.942V21.3H40V27A3,3,0,0,1,37,30ZM24.214,30H15.787V23.229l0-.4-.391-.087a4.423,4.423,0,0,1-1.968-1.283c-1.3-1.391-1.989-3.584-1.989-6.342a9.509,9.509,0,0,1,2-6.446,4.774,4.774,0,0,1,1.976-1.376l.373-.1V0h8.427V7.195l.371.1a4.779,4.779,0,0,1,1.978,1.377,9.509,9.509,0,0,1,2,6.446c0,2.758-.688,4.951-1.989,6.342A4.421,4.421,0,0,1,24.6,22.741l-.393.088,0,.4V30Zm-9.427,0H3a3,3,0,0,1-3-3V21.3H12v-.049a6.816,6.816,0,0,0,.75.942,5.693,5.693,0,0,0,2.034,1.392V30ZM40,20.3H28.534a12.008,12.008,0,0,0,1.026-5.189,12.732,12.732,0,0,0-.841-4.811H40v10Zm-28.534,0H0v-10H11.282a12.712,12.712,0,0,0-.842,4.811A12.012,12.012,0,0,0,11.465,20.3ZM40,9.306H28.235a7.37,7.37,0,0,0-.98-1.36,6.045,6.045,0,0,0-2.041-1.482V0H37a3,3,0,0,1,3,3v6.3Zm-28.236,0H0V3A3,3,0,0,1,3,0H14.787V6.463a6.036,6.036,0,0,0-2.041,1.482A7.33,7.33,0,0,0,11.765,9.3Z" transform="translate(0 0)" fill="#fff"/>
                                                        </svg>
                                                    </div>
                                                    <p class="acc_number m-0">No.Rek</p>
                                                    <h5 class="number fw-bold">0014 2154 3355 1803</h5>

                                                    <div class="branch_name fw-bold">
                                                        <p>KCP Ubud</p>
                                                        <svg xmlns="http://www.w3.org/2000/svg" width="43" height="28.289" viewBox="0 0 43 28.289">
                                                            <g id="mastercard_icon" transform="translate(-551 -339.628)">
                                                                <circle id="Ellipse_1" data-name="Ellipse 1" cx="14.145" cy="14.145" r="14.145" transform="translate(551 339.628)" fill="#fff" opacity="0.52"/>
                                                                <circle id="Ellipse_2" data-name="Ellipse 2" cx="14.145" cy="14.145" r="14.145" transform="translate(565.71 339.628)" fill="#fff"/>
                                                            </g>
                                                        </svg>
                                                    </div>
                                                </div>
                                            </label>
                                        </div>
                                    </swiper-slide>
                                    <div class="swiper-pagination" slot="pagination"></div>
                                </swiper>
                            </div>

                        </div> -->

                        <div class="modal fade" id="payment" data-backdrop="static" data-keyboard="false" tabindex="-1"
                            aria-labelledby="staticBackdropLabel" aria-hidden="true">
                            <div class="modal-dialog modal-dialog-centered">
                                <div class="modal-content">
                                    <div class="modal-body">
                                        <div class="text-center">
                                            <div v-if="message" class="alert alert-danger" role="alert">
                                                {{ message.message }}
                                            </div>
                                            <h3 class="title">Product Payment</h3>
                                            <p>Are you sure pay this product?</p>
                                        </div>
                                        <form @submit.prevent="handlePayment()">
                                            <input type="hidden" v-model="trans.transaction_id" class="form-control"
                                                readonly>
                                            <div class="row">
                                                <div class="col-lg-6 mx-auto">
                                                    <div
                                                        class="text-center button d-flex align-items-center justify-content-center">
                                                        <button type="button" class="btn btn_grey m-2"
                                                            data-dismiss="modal">No</button>
                                                        <button type="submit" class="btn btn_red" :disabled="loading">
                                                            <span v-show="loading"
                                                                class="spinner-border spinner-border-sm"></span>
                                                            Yes, I'm sure
                                                        </button>
                                                        <!-- <button type="button" @click="close()" class="btn btn_grey">Ragu</button> -->
                                                        <!-- <button type="button" @click="link()" class="btn btn-secondary">Test</button> -->
                                                    </div>
                                                </div>
                                            </div>
                                        </form>
                                        <!-- <div v-else class="row">
                                            <div class="col-lg-6 mx-auto">
                                                <div class="text-center button d-flex align-items-center justify-content-center">
                                                    <button type="button" class="btn btn_grey m-2" data-dismiss="modal">No</button>
                                                    <button type="submit" class="btn btn_red" :disabled="loading" @click="gotoPayment()">
                                                        <span v-show="loading" class="spinner-border spinner-border-sm"></span>
                                                        Yes, I'm sure
                                                    </button>

                                                </div>
                                            </div>
                                        </div> -->
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="modal fade" id="renew" data-backdrop="static" data-keyboard="false" tabindex="-1"
                            aria-labelledby="staticBackdropLabel" aria-hidden="true">
                            <div class="modal-dialog modal-dialog-centered">
                                <div class="modal-content">
                                    <div class="modal-body">
                                        <div class="text-center">
                                            <h3 class="title">Renew Product</h3>
                                            <p>Are you sure to Renew this product?</p>
                                            <div class="alert alert-danger" v-if="message">{{ message }}</div>
                                        </div>
                                        <form @submit.prevent="handleRenew()">
                                            <input type="hidden" v-model="subscription_id" class="form-control"
                                                readonly>
                                            <div class="row">
                                                <div class="col-lg-6 mx-auto">
                                                    <div
                                                        class="text-center button d-flex align-items-center justify-content-center">
                                                        <button type="button" class="btn btn_grey m-2"
                                                            data-dismiss="modal">No</button>
                                                        <button type="submit" class="btn btn_red">Yes, I'm sure</button>
                                                        <!-- <button type="button" @click="close()" class="btn btn_grey">Ragu</button> -->
                                                        <!-- <button type="button" @click="link()" class="btn btn-secondary">Test</button> -->
                                                    </div>
                                                </div>
                                            </div>
                                        </form>
                                    </div>
                                </div>
                            </div>
                        </div>

                    </div>
                </div>
            </section>
        </div>
    </div>
</template>

<script>
import DashHeader from "../layouts/Header.vue";
// import DashFooter from "../layouts/Footer.vue";
import Sidebar from "../layouts/Sidebar.vue";
import { dragscroll } from "vue-dragscroll";
import axios from 'axios'
import $ from 'jquery'

// import { Swiper, SwiperSlide, directive } from 'vue-awesome-swiper'
// import 'swiper/swiper-bundle.css'

export default {
    name: 'Payment',
    directives: {
        dragscroll,
        // swiper: directive
    },
    components: {
        DashHeader,
        Sidebar,
        // Swiper,
        // SwiperSlide
    },
    data() {
        return {
            serviceFee: 4500,
            transaction: [],
            subscription: [],
            broker: [],
            brokerName: '',
            artKey: '',
            brokerImage: '',
            message: '',
            loading: false,
            dataRobot: [],
            trans: {
                transaction_id: ''
            },
            subscription_id: '',
            // swiperOptions: {
            //     effect: 'coverflow',
            //     slidesPerView: 1.2,
            //     spaceBetween: 10,
            //     centeredSlides: true,
            //     pagination: {
            //         el: '.swiper-pagination',
            //         clickable: true
            //     },
            //     coverflowEffect: {
            //         rotate: 50,
            //         stretch: 0,
            //         depth: 100,
            //         modifier: 1,
            //         slideShadows : true
            //     },
            // }
        }
    },
    computed: {
        // swiper() {
        //     return this.$refs.mySwiper.$swiper
        // }
        // filterBroker(){
        //     return this.broker.filter(b => b.)
        // }
    },
    async mounted() {
        window.scrollTo(0, 0)


        try {
            // Fetch the transaction details
            const transactionResponse = await axios.get(`investor/${localStorage.getItem('user_id')}/transaction/${this.$route.params.id}/`);
            this.transaction = transactionResponse.data.data;
            this.subscription_id = this.transaction.subscription;

            // If a subscription ID exists, fetch the subscription details
            if (this.subscription_id) {
                try {
                    const subscriptionResponse = await axios.get(`subscription/${this.subscription_id}/`);
                    this.subscription = subscriptionResponse.data.data;
                } catch (error) {
                    console.log('Error fetching subscription: ', error.response);
                }
            }
        } catch (error) {
            console.log('Error fetching transaction: ', error.response);
        }

        await axios.get(`investor/robot/${this.transaction.product_id}/`)
            .then(response => {
                // console.log('Transaction: ', response.data.data)
                this.dataRobot = response.data.data
            }).catch(() => {
                // console.log('Error Robot: ', err.response)
            })
        await axios.get(`artkey/price/`)
            .then(response => {
                this.artKey = response.data.data.selling_price
            }).catch(() => {
                // console.log('Error Robot: ', err.response)
            })
        await axios.get(`broker/`)
            .then(response => {
                // console.log('Broker All: ', response.data.data)
                this.broker = response.data.data

                for (let i = 0; i < this.broker.length; i++) {
                    if (this.transaction.broker_choice == this.broker[i].id) {
                        // console.log('broker Detail: ', this.broker[i])
                        this.brokerName = this.broker[i].name
                        this.brokerImage = this.broker[i].logo
                    }
                }
            }).catch(() => {
                // console.log('Error Broker All: ', err.response)
            })
    },
    methods: {
        handlePayment() {
            this.loading = true
            let payload = new FormData()
            payload.append('transaction_id', this.transaction.id)
            // data.append('broker_account_id', this.broker.id)

            axios.post(`investor/${localStorage.user_id}/transaction/${this.transaction.id}/payment/`, payload)
                .then((response) => {
                    console.log("Masuk Payment BERHASIL", response);
                    this.loading = false
                    $('#payment').modal('hide')
                    window.open(response.data.data.payment_url, '_blank')
                    this.$router.push(`/subscriptions`)
                }).catch((err) => {
                    this.loading = false
                    this.message = err.data
                    console.log("Masuk Error Payment", err);
                })
        },
        gotoPayment() {
            this.loading = true
            $('#payment').modal('hide')
            window.open(this.transaction.payment_url, '_blank')
            this.$router.push(`/subscriptions`)
        },
        handleRenew() {
            let data = new FormData()
            data.append('transaction_id', this.transaction.id)
            data.append('deposit_amount', this.transaction.deposit_amount)
            // data.append('broker_account_id', this.broker.id)

            axios.post(`subscription/${this.subscription_id}/renew/`, data)
                .then(() => {
                    // console.log(response);
                    $('#renew').modal('hide')
                    // window.open(response.data.data.response.payment.url, '_blank')
                    this.$router.push(`/subscriptions`)
                }).catch((err) => {
                    console.error(err.response);
                    this.message = err.data.message
                })
        },
        formatPrice(value) {
            var priceElement = value;
            priceElement = priceElement.replace(/\D/g, '');
            var priceValue = priceElement.replace('.', '').split("").reverse().join(""); // reverse
            var newValue = '';
            for (var i = 0; i < priceValue.length; i++) {
                if (i % 3 == 0) {
                    newValue += '.';
                }
                newValue += priceValue[i];
            }
            priceElement = newValue.split("").reverse().join("");
            return priceElement;

        }
    }
}
</script>

<style>
.swiper {
    overflow-x: hidden;
    width: 100%;
}

/* .payment .card.card_payment{
    background: none !important;
    box-shadow: none;
} */
.card_payment .depo {
    color: var(--grey);
    font-weight: 600;
}

.payment_title {
    color: var(--grey);
    font-weight: 600;
}

.card_payment .money {
    color: var(--red);
    font-weight: 700;
    font-size: 28pt;
}

.card_item .card-header {
    padding-bottom: 0 !important;
    /* border-bottom: 1px solid red !important; */
}

.card_item .card-header h5 {
    font-weight: 700;
    color: var(--grey);
}

.card_item .item_image {
    width: 100%;
    height: 140px;
}

.card_item .item_image img {
    width: 100%;
    height: 100%;
    object-fit: cover;
    border-radius: 5px;
}

.card_item .item_name {
    font-weight: 700;
}

.card_item .item_title {
    font-weight: 600;
    font-size: 10pt;
    margin: 0;
}

.card_item .item_title.prices {
    display: flex;
    align-items: center;
}

.card_item .item_title.prices .text {
    width: 200px;
}

.card_item .item_value .badge {
    text-transform: uppercase;
    font-size: 10pt;
}

.card_item .item_value {
    font-size: 12pt;
}

.card_item .item_price {
    color: var(--red);
    font-weight: 700;
    font-size: 18pt;
}

.payment_card_container {
    margin: 20px 0;
    width: 100%;
    overflow: hidden;
    /* height: 280px; */
}

.card_group input.radio {
    display: none;
}

.card_group .bank_card {
    background: url('../assets/image/bank_card_bg_w.png') no-repeat, linear-gradient(-90deg, rgba(0, 0, 0, 0) 0%, rgba(0, 0, 0, 0.2) 100%) !important;
    color: var(--dark-grey);
    background-size: cover !important;
    background-position: center;
    box-shadow: 5px 5px 20px rgba(0, 0, 0, 0.1);
    transition: all 0.3s ease;
}

.card_group .bank_card .card-body .chip svg path,
.card_group .bank_card .card-body .branch_name svg circle {
    fill: #000;
}

.card_group .bank_card .card-header {
    margin: 0;
    padding-bottom: 0;
    /* border-bottom: 1px solid red; */
}

.card_group .bank_card .card-body .chip {
    margin: 0 0 10px;
}

.card_group .bank_card .card-body .acc_number {
    font-size: 8pt;
    margin: 0;
    font-weight: 500;
}

.card_group .bank_card .card-body .number {
    /* font-size: 10pt; */
    margin: 0;
    /* letter-spacing: 1px; */
    font-weight: 600;
}

.card_group .bank_card .card-body .branch_name {
    display: flex;
    align-items: bottom;
    justify-content: space-between;
    margin: 10px 0 0;
}

.card_group .bank_card .card-body .branch_name p {
    margin: 10px 0 0;
    font-weight: 500;
    text-transform: uppercase;
    font-size: 10pt;
}

.card_group input:checked~label {
    background: url('../assets/image/bank_card_bg.png') no-repeat, linear-gradient(90deg, rgba(22, 22, 22, 1) 0%, rgba(65, 65, 65, 1) 100%) !important;
    color: white;
    background-size: cover !important;
    background-position: center;
}

.card_group input:checked~.bank_card .card-body .chip svg path,
.card_group input:checked~.bank_card .card-body .branch_name svg circle {
    fill: #fff;
}

.button .btn_red {
    width: 100%;
    padding: 15px !important;
    text-transform: uppercase;
    font-size: 10pt;
}

.button .btn_red svg {
    margin-right: 4px;
}

.card_history .card-header {
    padding-bottom: 0 !important;
    border-bottom: 1px solid var(--light-grey) !important;
}

.card_history .card-header h5 {
    font-weight: 700;
    color: var(--grey);
}

.card_history .history_group {
    display: flex;
    align-items: center;
    justify-content: space-between;
    border-bottom: 1px solid var(--light-grey);
}

.card_history .history_group .history_text .name {
    font-weight: 700;
    font-size: 12pt;
    margin: 0;
}

.card_history .history_group .history_text .text {
    font-weight: 400;
    font-size: 10pt;
}

.card_history .history_group .history_text .time {
    font-weight: 400;
    font-size: 10pt;
    color: var(--grey);
    display: flex;
    align-items: center;
}

.card_history .history_group .history_text .time svg {
    margin-right: 5px;
}

.card_history .history_group .history_price svg {
    margin-right: 5px;
}

.card_history .history_group .history_price .money {
    color: var(--red);
    font-weight: 600;
    font-size: 12pt;
}
</style>
